import { useDispatch, useSelector, } from 'react-redux'
import { EventHandler, PopupDialogbox } from '../../CommonComponents'
import navSelectors from '../../../redux/Navigation/selectors';
import navOperations from '../../../redux/Navigation/operations';
import {setCartNav, showCatalogItemDetails, setSelectedVehiclesCount, setOrderDetails, setVehicleHistoryCardFlag, setActiveHeader,setSpliceFlag,setVehicleTypeFlag, setGrandTotal} from '../../../redux/MyOrder/action';
import {useRef, useEffect, useState, useCallback} from 'react'
import close from '../../assets/images/Close_SuccessPopup.svg'
import myOrderOperations from 'redux/MyOrder/operations';
import myOrderSelectors from 'redux/MyOrder/selectors';
import './Navigation.scss'
import permissions, { isAuthorized, isUserAuthorized } from 'client/utils/Permissions';
import { useNavigate } from 'react-router-dom';
import { resetOrderRequest } from 'client/utils/RequisitionUtil';
import ConfirmationBee from "../../assets/images/ConfirmationBee.svg";
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';
import { CONSTANTS } from 'client/utils/constants';
import { ReactToAPI } from 'Service/Transfer/ObjectStructure';
import { resetAllAssetOrderData } from "client/utils/AssetUtil";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { headerNav } from 'redux/Navigation/action';
import { setFleetItemId } from 'Store/AssetManagement/AssetNumber/AssetNumberAction';
import { setPurchaseorderStepperInfo } from 'redux/PurchaseOrder/action';
import { setTransferOrderById } from 'Store/Transfer/Transfer/TransferOrderByIdAction';
import { setApproversList, setCurrentSettings } from 'Store/OrderManagement/OutOfOffice/OutOfOfficeActions';
import { setApprovalManagmentTab } from 'Store/OrderManagement/ApprovalHistoryReport/ApprovalHistoryReportAction';
import { setDivisions } from 'Store/Organization/Divisions/DivisionsAction';
import { setSuperRegion } from 'Store/Organization/SuperRegion/SuperRegionActions';
import { setMarketDropDown } from 'Store/Organization/Market/MarketAction';
import { setRegionDropDown } from 'Store/Organization/Region/RegionAction';
import { setBranchDropDown } from 'Store/Organization/Branch/BranchAction';
import { setCostCenterByBranch } from 'Store/Organization/CostCenters/CostCentersAction';
import { setApprovalHierarchyBySuperRegion } from 'Store/OrderManagement/ApprovalHierarhy/ApprovalHierarhyAction';

const NavigationContainer = () => {
  const {
    isHeaderNav, isChangesOccured, headerNavItem, orderDetails,
    assets,
    cartAssets,
    getUserDetails,
    docList,
    transferOrderNumber,
    transferRequests,
    dispositionCartList,
    reactivationRequests,
    orderDetail,
    transferOrderByIdData,
    isChangesOccuredInCart,
    billOfSaleUrl
  }: any = useSelector(
    (state: any) => ({
      isHeaderNav: state.MyOrder.isHeaderNav,
      isChangesOccured: state.RequisitionReducer.isChangesOccured,
      headerNavItem: navSelectors.GetHeaderNav(state),
      orderDetails: myOrderSelectors.orderDetails(state),
      assets: state.TransferReducer.assets,
      cartAssets: state.TransferReducer.cartAssets,
      getUserDetails: state.UserProfile.getUserDetails,
      docList: state.UploadAttachmentsReducer.list,
      transferOrderNumber: state.TransferReducer.transferOrderNumber,
      transferRequests: state.TransferReducer.transferRequests,
      dispositionCartList: state.TransferReducer.dispositionCartList,
      reactivationRequests: state.TransferReducer.reactivationRequests,
      orderDetail: state.TransferReducer.orderDetails,
      transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
      isChangesOccuredInCart: state.TransferReducer.isChangesOccuredInCart,
      billOfSaleUrl: state.BillOfSaleReducer.billOfSaleUrl
    })
  )

    const menuList = [
    {
      text: 'Home',
      Item: 'Home',
      icon: 'home-icon',
      active: 'active',
      Title: 'Home'
    },
    {
      text: 'Orders',
      Item: 'Requests',
      icon: 'myorder-icon',
      Title: 'Orders'
    }
  ]

  if (isAuthorized(permissions.ViewTransfers)) {
    menuList.push(
      {
        text: 'Asset',
        Item: 'Asset',
        icon: 'asset-icon',
        Title: 'Asset'
      }
    )
  }

  if (isAuthorized(permissions.ViewBulkOrder)) {
    menuList.push(
      {
        text: 'Bulk Orders',
        Item: 'Bulk Orders',
        icon: 'bulkorder-icon',
        Title: 'Bulk Order'
      }
    )
  }

  if (isAuthorized(permissions.ViewCatalog)) {
    menuList.push(
      {
        text: 'CatalogManagement',
        Item: 'Catalog Mgmt',
        icon: 'ctlgmgmt-icon',
        Title: 'Catalog Management'
      }
    )
  }
  if (isAuthorized(permissions.ViewReports)) {
    menuList.push(
      {
        text: 'Reports',
        Item: 'Reports',
        icon: 'report-icon',
        Title: 'Reports'
      }
    )
  }
  if (isAuthorized(permissions.ViewAdmin)) {
    menuList.push(
      {
        text: 'Admin',
        Item: 'Admin',
        icon: 'admin-icon',
        Title: 'Admin'
      }
    )
  }
  
  if (isAuthorized(permissions.ViewHierarchy) || isAuthorized(permissions.ViewApprovalHistory) || isAuthorized(permissions.ViewComplianceReport)) {
  menuList.push(
    {
      text: 'Approval',
      Item: 'Approval',
      icon: 'approval-icon',
      Title: 'Approval'
    }
  )
  }

  if(isUserAuthorized()){
    menuList.push(
      {
        text: 'ActiveAsset',
        Item: 'Active Assets',
        icon: 'activeAsset-icon',
        Title: 'Active Assets'
      }
    )
   
    menuList.push(
      {
        text: 'ActiveAssetReport',
        Item: 'Active Assets Report',
        icon: 'activeAsset-icon activeAssetReport-icon',
        Title: 'Active Assets Report'
      }
    )
  }

  const dispatch = useDispatch();
  const dispatchNav = navOperations.dispatchNav(dispatch)
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch)
  const dispatchNavHeight = navOperations.dispatchNavHeight(dispatch)
  const dispatchSetOrderDetails = myOrderOperations.dispatchSetOrderDetails(dispatch);

  const[handleClickItem, setHandleClickItem] = useState<any>("");
  const [isSavedAsDraft, setIsSavedAsdraft] = useState<any>(false)
  const [confirmBtnClick, setConfirmBtnClick] = useState<any>(false);
  const [conformPopupcontent, setConformPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    additionalBtnText: "",
    additionalBtnnavigateTo: "",
    popupConfirmatioAdditionalbtnOnclick: () => { },
    popupOutlinebtnOnclick: () => { },
    popupPrimarybtnOnclick: () => { },
    isAdditionalConfirmationBtn: false
  });

  const navigate = useNavigate();

  const hideConformDialog = () => {
    setConformPopupcontent({ ...conformPopupcontent, isDialogVisible: false })
  };

  useEffect(() => {
    if (!isChangesOccured && confirmBtnClick && !isSavedAsDraft) {      
      hideConformDialog()
      handleClick(handleClickItem)
    }
  }, [isChangesOccured, confirmBtnClick])

  const confirmationPopup = () => {
    let decriptionTxt = (
      <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
    );
    setConformPopupcontent({
      ...conformPopupcontent,
      titleImg: ConfirmationBee,
      title: "UNSAVED CHANGES",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "No",
      primaryBtnText: "Yes",
      popupConfirmationOutlinebtnOnclick: () => {
        hideConformDialog();
      },
      popupConfirmationPrimarybtnOnclick: () => {
        setConfirmBtnClick(true);
        dispatch(TransferAction.setTransferOrderDetails({}));
        dispatch(RequisitionAction.setIsChangesOccured(false))
        dispatch(TransferAction.setIsChangesOccuredInCart(false))
        dispatch(TransferAction.setAfeReClassificationData({}))
      },
      isSingleConfirmationBtn: false,
    });
  }

  const draftSaveConfirmationPopup = (item?: any) => {
    let headerItem = item === "Orders" ? 'Customer My Orders' : item
    let decriptionTxt = (
      <p>Do you need to save the cart values as draft?</p>
    );
    
    // Check if user has permission to save drafts
    const canSaveDraft = isAuthorized(permissions.RequisitionsCreateUpdate) || isAuthorized(permissions.CreateUpdateTransfers);
    
    setConformPopupcontent({
      ...conformPopupcontent,
      titleImg: ConfirmationBee,
      title: "DRAFT CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "No",
      primaryBtnText: "Yes",
      additionalBtnText: "Cancel",
      isPrimaryBtnDisabled: !canSaveDraft, 
      popupConfirmationOutlinebtnOnclick: () => {
        dispatch(RequisitionAction?.setIsChangesOccured(false))
        dispatch(TransferAction.setIsChangesOccuredInCart(false))
        dispatch(TransferAction.setIsEditOrder(false));
        dispatch(TransferAction.setTransferOrderDetails({}));
        navigate('/ordermanagement')
        dispatchNav(headerItem);
        dispatchHeaderNav(headerItem);
        resetAllAssetOrderData(dispatch);
        hideConformDialog();
      },
      popupConfirmationPrimarybtnOnclick: () => {
        // Only proceed if user has permission
        if (!canSaveDraft) return;
        
        setConfirmBtnClick(true);
        hideConformDialog();
        let type : any = CONSTANTS.ORDER_SAVE
        let orderDetails : any = orderDetail
        dispatch(TransferAction.setIsSaveAsDraft(true))
        dispatch(TransferAction.setIsChangesOccuredInCart(false))
        dispatch(TransferAction.setTransferOrderNumber(""))
        dispatch(headerNav(headerItem))
        dispatch(TransferAction.setOrderCreationSuccess({}))
            ReactToAPI({
              orderDetails,
              getUserDetails,
              type,
              dispatch,
              docList,
              transferOrderNumber,
              transferRequests,
              dispositionCartList,
              assets,
              reactivationRequests,
              billOfSaleUrl
            })
      },
      popupConfirmatioAdditionalbtnOnclick: () => {
        hideConformDialog();
        dispatch(TransferAction.setIsChangesOccuredInCart(true))
      },
      isSingleConfirmationBtn: false,
      isAdditionalConfirmationBtn: true
    });
  }

  const handleClick = (item: any) => {
    setHandleClickItem(item)
    dispatch(setPurchaseorderStepperInfo([]))
    dispatch(setFleetItemId(null))
    dispatch(setCurrentSettings(null))
    dispatch(setApprovalManagmentTab(null))
    dispatch(setDivisions([]))
    dispatch(setSuperRegion([]))
    dispatch(setRegionDropDown([]))
    dispatch(setMarketDropDown([]))
    dispatch(setBranchDropDown([]))
    dispatch(setCostCenterByBranch([]))
    dispatch(setApprovalHierarchyBySuperRegion(null))
    dispatch(setApproversList([]))

    if((orderDetail?.requestType?.label == CONSTANTS?.TRANSFER || orderDetail?.requestType?.label == CONSTANTS?.DISPOSITION || orderDetail?.requestType?.label == CONSTANTS?.REACTIVATION || orderDetail?.requestType?.label == CONSTANTS?.AFEREQUEST)&& !confirmBtnClick && isChangesOccured){
      if(cartAssets?.length || assets?.length){
      if((orderDetail?.requestType?.label === CONSTANTS.DISPOSITION && cartAssets?.length && (transferOrderByIdData?.orderStatus == undefined)) || (orderDetail?.requestType?.label !== CONSTANTS.DISPOSITION && assets?.length && (transferOrderByIdData?.orderStatus == undefined)) || isChangesOccuredInCart){
        setIsSavedAsdraft(true)
        draftSaveConfirmationPopup(item);
      }
      else {
        setIsSavedAsdraft(false)
        confirmationPopup();
      } 
    }else {
        setIsSavedAsdraft(false)
        confirmationPopup();
      } 
    }else if(isChangesOccured && !confirmBtnClick){
      setIsSavedAsdraft(false)
      confirmationPopup();
    }else{
    setConfirmBtnClick(false);
    dispatch(setActiveHeader(item))
    dispatch(setCartNav(''));
    if(item === 'CatalogManagement'){
       navigate('/ordermanagement/CatalogManagement')
    } else if(item === 'Approval'){
      navigate('/ordermanagement/approval')
    }
    else if (item === 'ActiveAsset') {
      navigate('/ordermanagement/ActiveAsset')
    }
    else if (item === 'ActiveAssetReport') {
      navigate('/ordermanagement/ActiveAsset/Report')
    } 
    else if(item === 'Admin'){
      navigate('/ordermanagement/Admin/settings')
    } 
    else {
      navigate('/ordermanagement')
    } 
    if (item === 'Orders') {
      dispatchNav('Customer My Orders')
      dispatchHeaderNav('Customer My Orders');
    }
    else {
      dispatchNav(item);
      dispatchHeaderNav(item);
    }
    dispatch(showCatalogItemDetails(false));
    dispatch(setSelectedVehiclesCount(0));
    let OrderDetails = {
      vehicleType: '',
      vehicles: [],
      grandOrderTotal: 0
    }
    dispatch(setOrderDetails(OrderDetails))
    dispatch(setVehicleHistoryCardFlag(false))

    orderDetails.requests = [];
    dispatchSetOrderDetails(orderDetails);
    dispatch(setVehicleTypeFlag(false));
    dispatch(setSpliceFlag(false));
    dispatch(setGrandTotal(0))
    dispatch(setTransferOrderById({}))
    dispatch(TransferAction.setAfeOrderByIdData({}))
    // Reset Order Request Details
    resetOrderRequest(dispatch);
  }
  }

  
  const [height, setHeight] = useState(0)
  const ref: any = useRef(null)

  useEffect(() => {
    setHeight(ref.current?.clientHeight)
    dispatchNavHeight(height)
  }, [height])
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: ""
  });
  const hideDialog = useCallback(() => setPopupcontent({ ...Popupcontent, isDialogVisible: false }), [])
  const popupOutlinebtnOnclick = (item: any) => {
    dispatchNav(item);
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  }
  const returnOrderReq = () => {
    setPopupcontent({ ...Popupcontent, titleImg: ConfirmationBee, title: 'CONFIRMATION', isDialogVisible: true, isTitleWarning: false, subtextcontent: 'Are you sure you want to cancel the New Order', primaryBtnText: 'Yes', outlineBtnText: 'Cancel', isSingleConfirmationBtn: false, primaryBtnnavigateTo: (headerNavItem === "Customer My Orders") ? "Customer My Orders" : headerNavItem })
  }

  const MyOrderNav = () => {
    return (
      <div className='Myorder-mobile'>
        <EventHandler onEvent={() => returnOrderReq()} data-attribute="Navigation_Default_EventHandler_2">
          <div className='close'><img src={close} alt='close' title='close' /></div>
        </EventHandler>
      </div>
    )
  }
  const activeNavigation = useSelector((state: any) => state.nav.nav)
  const ActiveTabView = () => {
    switch (activeNavigation) {
      case "Home":
        return 
      case "My Orders":
        return <MyOrderNav />
      case "Managed Equipment":
        return <MyOrderNav />
      case "Non-Standard Equipment":
        return <MyOrderNav />
      default: break
    }
  }
  return (isHeaderNav && <>
    <div className='navigation-wrapper' id='navigation-wrapper' ref={ref}>
      <nav className='header-navigation'>
        <ul className={`navmenu-list ${activeNavigation !== 'Home' ? 'myorder-navigation' : ''}`}>
          {
            menuList.map((item, index) => {

              if (item.text === 'Orders' && !isAuthorized(permissions.RequisitionsView)) {
                return null
              }

              const myOrderTextVal = () => {
                if (item.text === 'Orders') {
                  return ('active');
                }
                else {
                  return ("")
                }
              }
              const assetTextVal = () => {
                if (item.text === 'Asset') {
                  return ('active');
                }
                else {
                  return ("")
                }
              }
              const bulkorderTextVal = () =>{
                 if (item.text === 'Bulk Orders') {
                  return ('active');
                }
                else {
                  return ("")
                }
              }
              const activeAssetTextVal = () =>{
                if (item.text === 'ActiveAsset') {
                  return ('active');
               }
               else {
                 return ("")
               }
             }
             const activeAssetReportTextVal = () =>{
              if (item.text === 'ActiveAssetReport') {
                return ('active');
             }
             else {
               return ("")
             }
           }
              const reportsTextVal = () =>{
                if (item.text === 'Reports') {
                 return ('active');
               }
               else {
                 return ("")
               }
             }
             const adminTextVal = () =>{
              if (item.text === 'Admin') {
               return ('active');
             }
             else {
               return ("")
             }
             }
             const approvalTextVal = () =>{
              if (item.text === 'Approval') {
               return ('active');
             }
             else {
               return ("")
             }
             }
             const catalogMgmtTextVal = () =>{
              if (item.text === 'CatalogManagement') {
               return ('active');
             }
             else {
               return ("")
             }
             }
              const homeTextVal = () => {
                if (item.text === 'Home') {
                  return ('active')
                } else {
                  return ('')
                }
              }
              const activeVal = () => {
                if(headerNavItem === item.text){
                  return('active')
                }else{
                  return('')
                }
              }
              return (            
                <EventHandler onEvent={() => { handleClick(item.text) }} data-attribute={`Navigation_${(item?.text || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                  <li key={index}
                    title={item.Title}
                    className={`
                      ${headerNavItem === 'Customer My Orders' ?  myOrderTextVal() : ''}
                      ${activeVal() ? homeTextVal() : ''}
                      ${headerNavItem === 'MyOrderDetail' ? myOrderTextVal() : ''}
                      ${headerNavItem === 'Asset' ?  assetTextVal() : ''}
                      ${headerNavItem === 'Bulk Orders' ?  bulkorderTextVal() : ''}
                      ${headerNavItem === 'Reports' ?  reportsTextVal() : ''}
                      ${headerNavItem === 'Admin' ?  adminTextVal() : ''}
                      ${headerNavItem === 'CatalogManagement' ?  catalogMgmtTextVal() : ''}
                      ${headerNavItem === 'Approval' ?  approvalTextVal() : ''}
                      ${headerNavItem === 'ActiveAsset' ?  activeAssetTextVal() : ''}
                      ${headerNavItem === 'ActiveAssetReport' ?  activeAssetReportTextVal() : ''}
                      `}
                      >

                    <a href='/' onClick={(e: any) => e.preventDefault()}><span className={`menu-icon ${item.icon}`}></span><p>{item.Item}</p></a></li>
                </EventHandler>)
            }

            )
          }
        </ul>
        <div className='search-block my-4 pe-3'>
          {ActiveTabView()}
        </div>
      </nav>
      <PopupDialogbox hideDialog={!Popupcontent.isDialogVisible} onDismiss={hideDialog} Popupcontent={Popupcontent} popupOutlinebtnOnclick={hideDialog} popupPrimarybtnOnclick={popupOutlinebtnOnclick}  data-attribute="Navigation_Default_PopupDilalogBox" />
      {conformPopupcontent.isDialogVisible ? 
        <CancelConfirmationPopup
          hideDialog={!conformPopupcontent.isDialogVisible}
          onDismiss={hideConformDialog}
          Popupcontent={conformPopupcontent}
          popupOutlinebtnOnclick={() => conformPopupcontent.popupConfirmationOutlinebtnOnclick()}
          popupPrimarybtnOnclick={() => conformPopupcontent.popupConfirmationPrimarybtnOnclick()}
          popupAdditionalBtnOnCLick = {() => conformPopupcontent.popupConfirmatioAdditionalbtnOnclick()}
        /> : ""}
    </div>
  </>)
}

export default NavigationContainer
